import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import styles from './my-account.module.css'
import {ReactComponent as Logo} from "./my-account-img/logo.svg";
import RoutesToPages from "../../assets/RoutesToPages/Routes";
import UnsubPopup from "../../components/UnsubPopup/UnsubPopup";
import ServerRequest from "../../ServerRequests/ServerRequest";
import Loader from "../../components/Loader/Loader";

const MyAccount = () => {
  const navigate = useNavigate();
  const myAccountRef = useRef(null);
  const timerFadeIn = useRef(null);
  const [isUnsubPopupShown, setIsUnsubPopupShown] = useState(false);
  const [userAuthData, setUserAuthData] = useState({
    phoneNumber: sessionStorage.getItem('phoneNumber') ?? 'Unknown',
    subscriptionType: sessionStorage.getItem('subscriptionType') ?? 'Daily',
    nextCharge: sessionStorage.getItem('nextCharge') ?? 'Some Info',
  });
  const [unsubMessageText, setUnsubMessageText] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (myAccountRef.current) {
      myAccountRef.current.classList.add(styles.myAccountFadeIn);
    }

    timerFadeIn.current = setTimeout(() => {
      myAccountRef.current.classList.remove(styles.myAccountFadeIn);
    }, 350)

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, []);


  //for the test flow
  // /* **************************************************************** */
  //
  // const handleUnsubscription = () => {
  //   setIsLoading(true);
  //
  //   if (userAuthData.phoneNumber === '96811111111') {
  //     setIsLoading(false);
  //     setIsUnsubPopupShown(true);
  //     setUnsubMessageText('You have successfully unsubscribed')
  //   } else if (userAuthData.phoneNumber === '96833333333') {
  //     setIsLoading(false);
  //     setIsUnsubPopupShown(true);
  //     setUnsubMessageText('Something went wrong')
  //   }
  // };
  //
  // /* **************************************************************** */


  const handleUnsubscription = async () => {
    setIsLoading(true);

    const serverData = await ServerRequest.unsubscribeUser(userAuthData.phoneNumber)
    const parsedServerData = await serverData.json();
    // console.log(serverData)
    // console.log(parsedServerData)

    if (parsedServerData.status === 200) {
      setIsLoading(false);
      setIsUnsubPopupShown(true);
      setUnsubMessageText('You have successfully unsubscribed')
    } else {
      setIsLoading(false);
      setIsUnsubPopupShown(true);
      setUnsubMessageText('Something went wrong')
    }
  };

  return (
    <div ref={myAccountRef}
         className={styles.myAccountGeneralContainer}>
      <div className={styles.myAccountInnerContainer}>
        <Logo className={styles.logo}/>
        <div className={styles.userDataAccount}>
          <p className={styles.userDataTitle}><span>Mobile number: </span>
            <span className={styles.userDataTitleValue}>{userAuthData.phoneNumber}</span>
          </p>
          <p className={styles.userDataTitle}><span>Subscription type: </span>
            <span className={styles.userDataTitleValue}>{userAuthData.subscriptionType}</span>
          </p>
          <p className={styles.userDataTitle}><span>Next charge: </span>
            <span className={styles.userDataTitleValue}>{userAuthData.nextCharge}</span>
          </p>
        </div>
        <button className={`${styles.myAccountBtn} ${userAuthData.phoneNumber === 'Unknown' && styles.disabled}`}
                onClick={handleUnsubscription}>
          Unsubscribe
        </button>
        <p className={styles.accountUnsubscribe}>
          To unsubscribe send UNSUB D to 92306 for Omantel and UNSUB DO to 92655 for Ooredoo
        </p>
      </div>
      <span className={styles.terms}
            onClick={() => navigate(RoutesToPages.terms)}>
          Terms & Conditions
        </span>
      {isUnsubPopupShown && <UnsubPopup isShown={isUnsubPopupShown}
                                        messageText={unsubMessageText}
      />}
      {isLoading && <Loader/>}
    </div>
  )
}

export default MyAccount;